import {gsap} from "gsap";

const RentalInsurance = {
    init(animate) {
        this.el = $('[module="rental"][section="insurance"]');
        if (!this.el.length) return;

        this.packageBtn = this.el.find('.packages button.toCart');
        this.extendedBtn = this.el.find('.extended button.toCart');
        this.continuedBtn = this.el.find('.button.next');
        this.boxes = this.el.find('[component="Box"]');

        this.bind();
        if (animate) this.animate();
    },

    bind() {
        this.packageBtn.on('click', this.setPackage);
        this.extendedBtn.on('click', (evt)=>this.setExtended(evt));
        this.continuedBtn.on('click', this.continue);
    },

    animate() {
        gsap.from(this.boxes, {opacity: 0, y: 100, stagger: 0.2, duration: 0.7, clearProps:true})
    },

    setPackage(evt) {
        $(evt.currentTarget).attr('load','');
        const box = $(this).closest('[component="Box"]');
        box.addClass('active').siblings().removeClass('active');
        const packageId = box.attr('item');
        Rental.load(null, {insurancePackage: packageId});
    },

    setExtended(evt) {
        let action = '';

        const btn = $(evt.currentTarget);
        btn.attr('load','').siblings().attr('load','')

        const box = btn.closest('[component="Box"]');
        const ExtendedId = box.attr('item');

        if (btn.hasClass('add')) {
            action = 'add';
            box.addClass('active');
        } else {
            action = 'cancel';
            box.removeClass('active');
        }

        Rental.load(null, {
            insuranceExtended: ExtendedId,
            action: action
        })
    },

    continue(evt) {
        Rental.load("/" + window.T.rental.base_url + "/" + window.T.rental.sections.accessories.url, null, 1)
    }
}

export default RentalInsurance;